<template>
    <svg :class="`icon icon-${icon}`">
        <use
            :href="svgUrl"
            :xlink:href="svgUrl"
        />
    </svg>
</template>

<script>
export default {
    name: 'Icon',
    computed: {
        svgUrl() {
            return `${this.publicPath}/svg/sprite.symbol.svg#${this.icon}`;
        },
    },
    props: {
        icon: {
            required: true,
            type: String,
        },
    },
};
</script>

<style lang="scss">
    .icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 1em;
        height: 1em;
        vertical-align: middle;
        fill: currentColor;
    }
</style>
